module.exports = __webpack_public_path__ + "app/assets/images/man3-16ea8b4a2028909bea6257b2f98f3997.jpg";